"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UndergroundIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _UndergroundInfo = require("../../../../types/UndergroundInfo");
var styles = _interopRequireWildcard(require("./styles.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const componentMap = {
  [_UndergroundInfo.EUndergroundType.Mow]: _uiKit.IconMetroMsk16,
  [_UndergroundInfo.EUndergroundType.Spb]: _uiKit.IconMetroSpb16,
  [_UndergroundInfo.EUndergroundType.Smr]: _uiKit.IconMetroSam16,
  [_UndergroundInfo.EUndergroundType.Ekb]: _uiKit.IconMetroEkb16,
  [_UndergroundInfo.EUndergroundType.Kzn]: _uiKit.IconMetroKzn16,
  [_UndergroundInfo.EUndergroundType.Nn]: _uiKit.IconMetroNN16,
  [_UndergroundInfo.EUndergroundType.Nsk]: _uiKit.IconMetroNovosib16
};
const UndergroundIcon = props => {
  const {
    undergroundType,
    lineColor
  } = props;
  const Icon = componentMap[undergroundType];
  if (Icon) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['underground-icon'],
      "data-testid": "underground_icon",
      style: {
        color: `#${lineColor}`
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      "data-testid": `underground_icon_${undergroundType}`,
      color: 'currentColor'
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['underground-icon--regions'],
    "data-testid": "underground_with_custom_icon",
    style: {
      color: `#${lineColor}`
    }
  });
};
exports.UndergroundIcon = UndergroundIcon;